'use strict';

const urlWithQueryParams = (url, params) => {
  const esc = encodeURIComponent;
  const query = Object.keys(params)
    .map(k => `${esc(k)}=${esc(params[k])}`)
    .join('&');
  return `${url}?${query}`;
};

module.exports = function(wrapped) {
  return function(...args) {
    let url;
    let opts;
    const csrfToken = document.querySelectorAll('meta[name="csrf-token"]')[0]
      .content;
    const defaultOptions = {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'x-response-format': 'json',
        'x-csrf-token': csrfToken,
      },
    };

    if (args.length === 2) {
      [url, opts] = args;
    } else {
      [url] = args;
      opts = {};
    }

    const { method, body } = opts;

    if (
      typeof body === 'object' &&
      (!method ||
        (typeof method === 'string' && method.toLowerCase() === 'get'))
    ) {
      url = urlWithQueryParams(url, body);
      delete opts['body']; //this trick is neccessary in case the polyfill version of fetch is used
    }

    const mergedOpts = {
      ...defaultOptions,
      ...opts,
      headers: { ...defaultOptions.headers, ...opts.headers },
    };
    return wrapped.apply(this, [url, mergedOpts]);
  };
};
